import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faClock,
  faCopy,
  faDrawPolygon,
  faMapLocationDot,
  faMobileScreenButton,
  faQrcode,
  faUserPlus,
} from '@fortawesome/free-solid-svg-icons'
import { useNavigate } from 'react-router-dom'
import { Screen } from 'src/screens'
import { Wrapper } from './styles'
import { useSelector } from 'react-redux'
import { usersSelector } from 'src/state/selectors'

const getAppUrl = `${process.env.REACT_APP_MENU_BASE_URL}/get-app`
const INSTALL_KEY = 'consumerOrders:installAppClicked'
const QR_KEY = 'consumerOrders:qrViewed'
const MENU_COPY_KEY = 'consumerOrders:menuLinkCopied'

export default function SetupPanel() {
  const navigate = useNavigate()
  const { user } = useSelector(usersSelector)
  const [installClicked, setInstallClicked] = useState(sessionStorage.getItem(INSTALL_KEY) === 'true')
  const [qrViewed, setQrViewed] = useState(Boolean(localStorage.getItem(QR_KEY)))
  const [menuCopied, setMenuCopied] = useState(Boolean(localStorage.getItem(MENU_COPY_KEY)))

  const hasCoords = Boolean(user?.coords?.latitude && user.coords?.longitude)
  const hasSchedule = Boolean(user?.schedule?.schedule?.length)
  const hasDeliveryZones = Boolean(user?.ordering?.deliveryZonesConfig?.zones?.length)
  const hasActiveWaiter = Boolean(user?.devices?.some(device => device.isPushNotificationsEnabled))
  const hasAnyWaiter = Boolean(user?.devices?.length)

  const isInstallDone = hasActiveWaiter || installClicked
  const isQrViewed = qrViewed

  const openWaiterLogin = () => window.openWaiterLoginModal?.()
  const goToLocation = () => navigate(Screen.SetLocation)
  const goToSchedule = () => navigate(Screen.SetSchedule)
  const installApp = () => {
    sessionStorage.setItem(INSTALL_KEY, 'true')
    setInstallClicked(true)
    window.open(getAppUrl, '_blank')
  }
  const openQrModal = () => {
    localStorage.setItem(QR_KEY, 'true')
    setQrViewed(true)
    window.openMyQrCodeModal?.()
  }
  const copyMenuLink = () => {
    const menuUrl = `${process.env.REACT_APP_MENU_BASE_URL}/${user?.username}`
    navigator.clipboard?.writeText(menuUrl)
    localStorage.setItem(MENU_COPY_KEY, 'true')
    setMenuCopied(true)
    window.showConfirm({ text: `Linkul către meniul tău a fost copiat în clipboard.\n\n ${menuUrl}` })
  }

  return (
    <Wrapper>
      <label>Configurează</label>
      <div className="setup-actions">
        <div className="setup-item" data-completed={hasActiveWaiter} onClick={openWaiterLogin}>
          <FontAwesomeIcon icon={faUserPlus} />
          Adaugă ospătar
        </div>
        <div className="setup-item" data-completed={hasCoords} onClick={goToLocation}>
          <FontAwesomeIcon icon={faMapLocationDot} />
          Setează locația restaurantului
        </div>
        <div className="setup-item" data-completed={hasSchedule} onClick={goToSchedule}>
          <FontAwesomeIcon icon={faClock} />
          Setează programul de lucru
        </div>
        <div className="setup-item" data-completed={hasDeliveryZones} onClick={() => navigate(Screen.SetDeliveryZones)}>
          <FontAwesomeIcon icon={faDrawPolygon} />
          Setează zonele de livrare
        </div>
        <div className="setup-item" data-completed={isInstallDone || hasAnyWaiter} onClick={installApp}>
          <FontAwesomeIcon icon={faMobileScreenButton} />
          Instalează aplicația
        </div>
        <div className="setup-item" data-completed={isQrViewed} onClick={openQrModal}>
          <FontAwesomeIcon icon={faQrcode} />
          Vezi codul tău QR
        </div>
        <div className="setup-item" data-completed={menuCopied} onClick={copyMenuLink}>
          <FontAwesomeIcon icon={faCopy} />
          Copiază link meniu
        </div>
      </div>
    </Wrapper>
  )
}
